export default function R_MaxMin() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_MaxMin Component</h1>
      <p>This is the R_MaxMin tutorial section.</p>
    </div>
  );
}
